// src/lib/socket.js
import { io } from 'socket.io-client';
import { wsUpdateStatus, wsNewRequest, fetchAllWithdrawals } from '../store/Slices/withdrawSlice';

const SOCKET_URL = 'https://junior-georgetta-hassanyouz-eb3e69f6.koyeb.app/' || 'https://junior-georgetta-hassanyouz-eb3e69f6.koyeb.app';

const socket = io(SOCKET_URL, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
});

let isConnected = false;
let handlersRegistered = false;
let currentUserId = null;
let currentIsSupport = false;

/**
 * سجل جميع المستمعات في مكان واحد، مرة واحدة فقط.
 */
function registerHandlers(dispatch) {
  if (handlersRegistered) return;

  // اتصال/انفصال
  socket.on('connect', () => {
    console.log('Socket.IO connected:', socket.id);
  });
  socket.on('connect_error', (error) => {
    console.error('Socket.IO connection error:', error.message);
    isConnected = false;
  });
  socket.on('disconnect', () => {
    console.log('Socket.IO disconnected');
    isConnected = false;
  });

  // === أحداث الذكاء الاصطناعي/الأسعار (الموجودة لديك سلفاً) ===
  socket.on('current_price', (data) => {
    if (!data?.price || isNaN(data.price)) {
      console.warn('Invalid price data received:', data);
      return;
    }
    dispatch({ type: 'aiTrading/updateCurrentPrice', payload: data });
  });

  socket.on('price_prediction', (data) => {
    console.log('Received price prediction:', data);
    dispatch({ type: 'aiTrading/updatePricePrediction', payload: data });
  });

  socket.on('trade_opened', (data) => {
    console.log('Trade opened:', data);
    dispatch({ type: 'aiTrading/addTrade', payload: data });
  });

  socket.on('trade_closed', (data) => {
    console.log('Trade closed:', data);
    dispatch({ type: 'aiTrading/updateTrade', payload: { ...data, status: 'Completed' } });
  });

  socket.on('margin_deduction', (data) => {
    console.log('Margin deduction:', data);
    dispatch({ type: 'aiTrading/setError', payload: data.message });
  });

  // === أحداث السحب ===
  // تحديث حالة طلب سحب لمستخدم معيّن (الغرفة: userId)
  socket.on('withdrawal_status', (payload) => {
    // payload: { id, status, txid? }
    dispatch(wsUpdateStatus(payload));
  });

  // وصول طلب سحب جديد لقسم الدعم (الغرفة: "support")
  socket.on('withdrawal_new', (payload) => {
    // payload: { requestId } أو الطلب كامل (حسب ما ترسله من السيرفر)
    // الأفضل تحديث القائمة من السيرفر لضمان التزامن:
    dispatch(fetchAllWithdrawals());
    if (payload?.requestId) dispatch(wsNewRequest({ _id: payload.requestId }));
  });

  handlersRegistered = true;
}

/**
 * تهيئة/تحديث الاتصال:
 * - ينضم المستخدم إلى غرفته الخاصة.
 * - إن كان موظف دعم ينضم أيضاً إلى غرفة support.
 */
export const initializeSocket = (dispatch, userId, isSupport = false) => {
  registerHandlers(dispatch);

  // إذا تغيّر المستخدم المسجل أو حالة كونه Support
  const needReconnect =
    !isConnected ||
    currentUserId !== userId ||
    currentIsSupport !== isSupport;

  currentUserId = userId || null;
  currentIsSupport = !!isSupport;

  if (!userId) return socket;

  if (needReconnect) {
    if (!isConnected) {
      socket.connect();
      isConnected = true;
    }
    // انضمام لغرفة المستخدم
    socket.emit('join', { user_id: userId });
    // إن كان Support انضم لغرفة الدعم أيضاً
    if (isSupport) {
      socket.emit('join_support');
    }
  }

  return socket;
};

export const disconnectSocket = () => {
  if (isConnected) {
    socket.off('connect');
    socket.off('connect_error');
    socket.off('disconnect');
    socket.off('current_price');
    socket.off('price_prediction');
    socket.off('trade_opened');
    socket.off('trade_closed');
    socket.off('margin_deduction');

    socket.off('withdrawal_status');
    socket.off('withdrawal_new');

    socket.disconnect();
    isConnected = false;
    handlersRegistered = false;
    currentUserId = null;
    currentIsSupport = false;
    console.log('Socket.IO disconnected');
  }
};

export default socket;
